import { render } from "./Römisch.vue?vue&type=template&id=7011d2fa&scoped=true"
import script from "./Römisch.vue?vue&type=script&lang=js"
export * from "./Römisch.vue?vue&type=script&lang=js"

import "./Römisch.vue?vue&type=style&index=0&id=7011d2fa&scoped=true&lang=css"

import exportComponent from "/builds/prv-dkomm/projects/edtools/zyklus3/ba-2021-trieu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7011d2fa"]])

export default __exports__